// TestReusableParent.js
import { useState } from 'react';
import TestReusableTable from './TestReusableTable';

const TestReusableParent = () => {
  // Example data
  const data = [
    { id: 1, name: 'John Doe', age: 28, country: 'USA' },
    { id: 2, name: 'Jane Smith', age: 34, country: 'UK' },
    { id: 3, name: 'Albert Johnson', age: 24, country: 'Canada' },
    { id: 4, name: 'Mary Lou', age: 42, country: 'Australia' },
  ];

  // Table columns configuration
  const columns = [
    { Header: 'ID', accessor: 'id' },
    { Header: 'Name', accessor: 'name' },
    { Header: 'Age', accessor: 'age' },
    { Header: 'Country', accessor: 'country' },
  ];

  // State to store the filters
  const [filters, setFilters] = useState({
    id: '',
    name: '',
    age: '',
    country: '',
  });

  // Function to handle filter change
  const handleFilterChange = (column, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [column]: value,
    }));
  };

  return (
    <div>
      <h1>Reusable Table with Filters</h1>
      <TestReusableTable
        columns={columns}
        data={data}
        filters={filters}
        onFilterChange={handleFilterChange}
      />
    </div>
  );
};

export default TestReusableParent;
